import React from 'react';
import Typography from '@src/new-components/Typography';
import { Box } from '@mui/material';
import { COLOR } from '@src/styles/color';
import { VoiceLanguageContainer, SmallAvatarStyled } from './index.style';

const VoiceLanguage = ({ icon, language, region }) => (
  <VoiceLanguageContainer>
    <SmallAvatarStyled src={icon} />
    <Box display="flex" flexDirection="column" gap={0.5}>
      <Typography variant="body-14-regular" color={COLOR.darkGray}>
        {language}
      </Typography>
      {region && (
        <Typography variant="body-12-regular" color={COLOR.label2[64]}>
          {region}
        </Typography>
      )}
    </Box>
  </VoiceLanguageContainer>
);

export default VoiceLanguage;
